
import { SearchableDropdown } from 'components/SearchableDropdown';
import { PhoneSourceHolder } from 'features/Dealers/Listings/Data/styles';
import * as React from 'react';
import { PhoneSourceNumber } from './state/types';


interface Props {
    phones?: PhoneSourceNumber[]
    //isLoadingPhones: boolean
    selectedPhone?: string    
    onPhoneSelected: (phone: PhoneSourceNumber) => void
    displayAll?: boolean
}

const PhoneSelect = (props: Props) => {
    const suggestItems = React.useMemo(() => {
        if (props.phones) {
            return props.phones.map(phone => ({
                id: phone.source,
                //displayName: (phone.source==="GMB"?"GBP":phone.source) +  (phone.number!=""?" (" + phone.number + ")":"")
                displayName: (phone.source==="GMB"?"GBP":phone.source) +  (phone.number!="" && (props.displayAll??true) ?" (" + phone.number + ")":"")
            }))
        }
        return undefined;

    }, [props.phones])
       const selectedOption = React.useMemo(() => {
        if (props.selectedPhone && props.phones) {
            let selphone = props.phones.find(f=> f.source == props.selectedPhone);
            return {
                id: selphone? selphone.source:"",
                displayName: selphone? (selphone.source==="GMB"?"GBP":selphone.source):""                
            }
        }
        return undefined
    }, [props.selectedPhone])

    if (!props.phones) {
        return null
    }

    return (
        <PhoneSourceHolder>
            <SearchableDropdown
                selectedOption={selectedOption}
                value={""}
                options={suggestItems}
                isLoading={false}
                canLoadMoreOptions={false}
                emptyText={getEmptyText()}
                placeholder={"Select source"}
                readonly={false}
                onValueChange={(v) => onSearchQueryChange(v)}
                onOptionSelected={onSelectedItem}
                onDrawerDismissed={onDrawerDismissed}
                onLoadMoreOptions={loadMoreOptions}       
                notSearchable={true}     
                inputStyle={{                    
                    height:"30px"
                }}        
                labelStyle={{
                    padding: "0 0 10px 10px",
                    fontSize: "14px"
                }}
            />
        </PhoneSourceHolder>
    )

    function onSearchQueryChange(query) {
        //props.onQueryChange(query);
    }

    function loadMoreOptions() {
        //props.loadCategories()
    }

    function getEmptyText() {      
        return `No Phones found`
    }

    function onDrawerDismissed() {
        //props.onQueryChange("")
    }

    function onSelectedItem(item) {
        const allPhones = props.phones ?? []
        const phone = allPhones.find(d => d.source === item.id)
        if (phone) {
            props.onPhoneSelected(phone)
        }
    }
}

export default PhoneSelect;
